import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { organisationQueryOptions } from '@/api/resources/organisations'

export const Route = createFileRoute('/_app/users/$organisationId')({
  beforeLoad: async ({ params, context }) => {
    const organisationId = Number(params.organisationId)
    if (Number.isNaN(organisationId)) {
      throw redirect({ to: '/users' })
    }

    const organisation = await context.queryClient.ensureQueryData(
      organisationQueryOptions(organisationId),
    )

    return { organisation }
  },
  component: UsersOrganisationLayout,
})

function UsersOrganisationLayout(): React.ReactElement {
  return <Outlet />
}
